import { ICompaniaModel } from "../interfaces/compania/ICompaniaModel";

export class CompaniaModel implements ICompaniaModel {
    idCompania: number;
    nombre: string;
    main: boolean;
    isDefault: boolean;
    constructor() {
        this.idCompania = 0;
        this.nombre = '';
        this.main = false;
        this.isDefault = false;
    }
}
